// Utils
import RENTAL_EVENT_TYPES from '../enum/RentalEventTypes';
import TRANSACTION_TYPES from '../../terminals/enums/TransactionType';

/**
 * Reformat rental events by event type
 * and sum the amounts by event type
 * and sort by local transaction date time
 * @param {Array} rentalEvents
 * @returns {Array} Reformatted rental events
 */
export const reformatRentalEvents = (rentalEvents) => {
    const reformattedRentalEvents = [];

    Object.values(RENTAL_EVENT_TYPES).forEach(eventType => {
        // Filter the rental events by event type and transaction type debit only (no reversal)
        const rentalEvent = rentalEvents.find(event =>
            event.eventType === eventType.name && event.transactionType !== TRANSACTION_TYPES.DEBIT_REVERSAL.name
        );

        if (rentalEvent) {
            reformattedRentalEvents.push({
                ...rentalEvent,
                amount: rentalEvents
                    .filter(event =>
                        // Filter the rental events by event type and transaction type debit only (no reversal)
                        event.eventType === eventType.name && event.transactionType !== TRANSACTION_TYPES.DEBIT_REVERSAL.name
                    )
                    .reduce((acc, event) => acc + event.amount, 0)
            });
        }
    });
    return reformattedRentalEvents.sort((a, b) =>
        new Date(a.localTransactionDateTime) - new Date(b.localTransactionDateTime));
};